import { Checkbox } from 'primereact/checkbox';
import { useFormContext } from 'react-hook-form';
import { capitalizeString } from '../../../../utils/formatUtils';

type SectionAccordionHeaderProps = {
  section: string;
  checkedModules: Record<string, boolean>;
  updateSection: (section: string, checked: boolean) => void;
  startIndex: number;
  count: number;
};

const SectionAccordionHeader = ({
  section,
  checkedModules,
  updateSection,
  startIndex,
  count,
}: SectionAccordionHeaderProps) => {
  const { setValue } = useFormContext();

  return (
    <div className="flex align-items-center">
      <span className="text-standard">{capitalizeString(section)}</span>
      <Checkbox
        className="ml-4"
        checked={checkedModules[section]}
        onChange={(e) => {
          updateSection(section, e.checked);
          for (let i = startIndex; i < startIndex + count; i++) {
            setValue(`access.${i}.selected`, e.checked);
          }
        }}
      />
    </div>
  );
};
export default SectionAccordionHeader;
